import { en } from './en'
import { fr } from './fr'

export const footer = {
  en,
  fr
}